import { appAuthIdentity } from '@/hooks/useIsAuthenticated';
import { configureAuthIdentity } from '@heidi/auth/state';

configureAuthIdentity(appAuthIdentity);
